module.exports = __webpack_public_path__ + "img/zoom-plus.d3522460.svg";